import makeSelectEntityFilters from './make-select-entity-filters';
import {createSelector} from '@reduxjs/toolkit';
import {ResourceName} from 'types/resource-name';

export default (name: ResourceName) =>
  createSelector(makeSelectEntityFilters(name), filters => {
    return filters?.limit;
  });
